module.exports = __webpack_public_path__ + "static/media/rocketchat.6d49ddd9.svg";